import { store } from "@/store"
import { signupWithRedirect } from "@/composables/useAccount.js"

const manageGuard = ({ params: { id } }, from, next) => {
  store.dispatch("subscription/checkIfExists", id)
    .then(() => next())
    .catch(() => next("/"))
}

const signupGuard = () => signupWithRedirect()

export {
  manageGuard,
  signupGuard,
}
